const content = "_content_vnv5k_8";
const contextStyles = {
  content
};
export {
  content,
  contextStyles as default
};
//# sourceMappingURL=ContextMenu.module.css.js.map
